import type {ReactElement} from 'react';
import React from 'react';
import type {ColorStorage} from '@Components/color-picker-v2';
import type {RGBA} from '@Utils/color.util';
import {PosterEditingBaseColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-base-color-panel';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromQRItem} from '@Hooks/poster-editor/useGetKeyFromQRItem';

export function QrForegroundColorPanel(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const itemQrForegroundColor = useGetKeyFromQRItem('qrForegroundColor');

  if (!activeItem || (activeItem && !('qrForegroundColor' in activeItem)) || !itemQrForegroundColor) {
    throw new Error(`QR Item doesn't have qrForegroundColor property`);
  }

  const getColorFillColors = (): ColorStorage[] => {
    return [
      {
        id: 'primary',
        color: itemQrForegroundColor,
      },
    ];
  };

  const updateQrForegroundColor = (qrForegroundColor: RGBA, undoable = true): void => {
    activeItem.updateForegroundColor(qrForegroundColor, undoable);
  };

  const onChangeColorFillColor = (updatedColor: ColorStorage[]): void => {
    updateQrForegroundColor(updatedColor[0].color, false);
  };

  const onChangeColorEnded = (updatedColor: ColorStorage[]): void => {
    updateQrForegroundColor(updatedColor[0].color);
  };

  return (
    <PosterEditingBaseColorPanel
      id="qr-foreground-color-panel"
      color={getColorFillColors()}
      onChangeColor={onChangeColorFillColor}
      onChangeEnded={onChangeColorEnded}
      isGradientEnabled={false}
    />
  );
}
